import { atom } from "jotai";

export const templatesAtom = atom([]);

export const templateDrawerAtom = atom(false);
export const previewDrawerAtom = atom(false);
export const resumeDownloadingAtom = atom({ beingDownloaded: false, downloaded: false });
export const confirmDownloadingAtom = atom(false);
